@for (message of messages; track $index) {
  {{ message }}
}
